import React from "react";
import PricingProfileListItem from "../../components/pricingProfile/PricingProfileList/PricingProfileListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const PricingProfileListPage = ()  => {

    useTitle(t`List Pricing Profile`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <PricingProfileListItem showAdd={true} {...query} />
        </Box>
    )
}

export default PricingProfileListPage;
